import { render, staticRenderFns } from "./KoioteGraficoLinealProperties.vue?vue&type=template&id=59fa7f5e&lang=es"
import script from "./KoioteGraficoLinealProperties.vue?vue&type=script&lang=js"
export * from "./KoioteGraficoLinealProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports